import { checkAuth } from 'webReservations/auth/apiHelpers';
import {
  AuthModalTypes,
  useAuthModalContext,
} from 'webReservations/context/AuthModalContext';
import { useUserContext } from 'webReservations/context/UserContext';
import { useNavigate } from 'react-router-dom';

export const useLoginOrCheckout = () => {
  const navigate = useNavigate();
  const { setIsAuthenticated, clearUserState } = useUserContext();
  const { openModal } = useAuthModalContext();

  const loginOrCheckout = async (checkoutPath: string) => {
    const response = await checkAuth();

    if (response.isAuthenticated) {
      setIsAuthenticated(true);
      navigate(checkoutPath);
    } else {
      clearUserState();
      openModal(AuthModalTypes.SIGN_IN, {
        onAuthSuccess: () => navigate(checkoutPath),
      });
    }
  };

  return {
    loginOrCheckout,
  };
};
